// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-callout-budget[data-v-21a539b7] .callout-container {\n  border-left-width: 5px;\n}", ""]);
// Exports
module.exports = exports;
